import axios from 'axios';
import { API_ERROR, API_BASE_PATH, AEM_API_BASE_PATH, CIP_LOGOUT_URL, DEBUG_MODE, ADDRESS_API_BASE_PATH } from '../app-constants';
import {
  getAuthorizationAccessToken,
  clearSessionStorage,
  getEventRouteAndUserHashDetails,
  getAuthorizationAccessTokenSecureAuth,
} from '../app-actions';


export const apiError = (id, error) => ({ type: `${API_ERROR}_${id}`, error });

const apiInstance = axios.create({
  baseURL: API_BASE_PATH,
});

// create api (axios) instance for AEM
const aemApiInstance = axios.create({
  baseURL: AEM_API_BASE_PATH,
});

const handleVantageAndMBSUndefinedError = (dispatch, failureFunc, error) => {
  if (DEBUG_MODE) {
    console.log(error); // eslint-disable-line
  } else if (getEventRouteAndUserHashDetails().isEventRouteAndUserHashPresent) {
    // redirect to error page if it vantage view and debug mode is false
    dispatch(failureFunc(error));
  } else {
    clearSessionStorage(CIP_LOGOUT_URL);
  }
};

// get request
export const apiGet = (dispatch, endpoint, success, failure) => apiInstance.get(endpoint,
  { headers: { Pragma: 'no-cache', Authorization: getAuthorizationAccessToken() } })
  .then((response) => {
    dispatch(success(response.data));
  })
  .catch((error) => {
    if (error.response && error.response.data && error.response.data.message && error.response.status !== 401) {
      sessionStorage.setItem('errorMessage', error.response.data.message);
      dispatch(failure(error));
    } else if (error.response === undefined) { // response will be undefined when okapi has rejected the request due to expired/incorrect token
      handleVantageAndMBSUndefinedError(dispatch, failure, error);
    } else if (error.response && error.response.status === 401) {
      clearSessionStorage(CIP_LOGOUT_URL);
    } else {
      dispatch(failure(error));
    }
  });

export const apiPost = (dispatch, endpoint, success, failure, params) => apiInstance.post(endpoint,
  { data: { ...params } },
  { headers: { Pragma: 'no-cache', Authorization: getAuthorizationAccessToken() } })
  .then((response) => {
    dispatch(success(response.data));
  })
  .catch((error) => {
    if (error.response && error.response.data && error.response.data.message && error.response.status !== 401) {
      sessionStorage.setItem('errorMessage', error.response.data.message);
      dispatch(failure(error));
    } else if (error.response === undefined) { // response will be undefined when okapi has rejected the request due to expired/incorrect token
      handleVantageAndMBSUndefinedError(dispatch, failure, error);
    } else if (error.response && error.response.status === 401) {
      clearSessionStorage(CIP_LOGOUT_URL);
    } else {
      dispatch(failure(error));
    }
  });

// get request for AEM
export const aemApiGet = (dispatch, endpoint, success, failure) => aemApiInstance.get(endpoint)
  .then((response) => {
    dispatch(success(response.data));
  })
  .catch((error) => {
    dispatch(failure(error));
  });

// get file request
export const apiFileGet = (dispatch, endpoint, success, failure) => apiInstance(
  { method: 'get',
    url: endpoint,
    responseType: 'blob',
    headers: { Pragma: 'no-cache', Authorization: getAuthorizationAccessToken() },
  })
  .then((response) => {
    dispatch(success(response));
  })
  .catch((error) => {
    if (error.response && error.response.data && error.response.data.message) {
      sessionStorage.setItem('errorMessage', error.response.data.message);
    } else if (error.response === undefined) { // response will be undefined when okapi has rejected the request due to expired/incorrect token
      handleVantageAndMBSUndefinedError(dispatch, failure, error);
    }
    if (error.response && error.response.status === 401) {
      clearSessionStorage(CIP_LOGOUT_URL);
    } else {
      dispatch(failure(error));
    }
  });


// post file request
export const apiFilePost = (dispatch, endpoint, success, failure, params) => apiInstance(
  { method: 'post',
    data: { ...params },
    url: endpoint,
    responseType: 'blob',
    headers: { Pragma: 'no-cache', Authorization: getAuthorizationAccessToken() },
  })
  .then((response) => {
    dispatch(success(response));
  })
  .catch((error) => {
    if (error.response && error.response.data && error.response.data.message) {
      sessionStorage.setItem('errorMessage', error.response.data.message);
    } else if (error.response === undefined) { // response will be undefined when okapi has rejected the request due to expired/incorrect token
      handleVantageAndMBSUndefinedError(dispatch, failure, error);
    }
    if (error.response && error.response.status === 401) {
      clearSessionStorage(CIP_LOGOUT_URL);
    } else {
      dispatch(failure(error));
    }
  });

// setup for cancellatble api calls

// for canceling pending addresss search requests
let cancelCall;

const addressApiInstance = axios.create({
  baseURL: ADDRESS_API_BASE_PATH,
});


export const cancellalableApiGet = (endpoint, data) => {
  if (cancelCall) {
    cancelCall.cancel();
  }
  cancelCall = axios.CancelToken.source();
  return addressApiInstance
    .get(endpoint + data, { cancelToken: cancelCall.token })
    .then(response => response.data)
    .catch((error) => {
      if (axios.isCancel(error) && DEBUG_MODE) {
        console.log('Request canceled', error.message); // eslint-disable-line
      } else {
        console.log(error); // eslint-disable-line
      }
    });
};

export const apiGetWithoutDispatch = endpoint => apiInstance.get(endpoint,
  { headers: { Pragma: 'no-cache', Authorization: getAuthorizationAccessToken() } })
  .then(response => response.data)
  .catch((error) => {
    console.log(error); // eslint-disable-line
  });


export const apiGetDirect = (dispatch, endpoint, success, failure) => axios.get(endpoint,
  { headers: { Pragma: 'no-cache', Authorization: getAuthorizationAccessTokenSecureAuth() } })
  .then((response) => {
    dispatch(success(response.data));
  })
  .catch((error) => {
    if (error.response && error.response.data && error.response.data.message && error.response.status !== 401) {
      sessionStorage.setItem('errorMessage', error.response.data.message);
      dispatch(failure(error));
    } else if (error.response === undefined) { // response will be undefined when okapi has rejected the request due to expired/incorrect token
      handleVantageAndMBSUndefinedError(dispatch, failure, error);
    } else if (error.response && error.response.status === 401) {
      clearSessionStorage(CIP_LOGOUT_URL);
    } else {
      dispatch(failure(error));
    }
  });

export const apiGetWithoutDispatchWithoutHeaders = endpoint => axios.get(endpoint)
  .then(response => response.data)
  .catch((error) => {
  console.log(error); // eslint-disable-line
  });


export const apiPostWithoutDispatchCustom = options => axios(options)
  .then(response => response.data)
  .catch((error) => {
    console.log(error); // eslint-disable-line
  });

export const apiPostCustom = (dispatch, options, success, failure) => axios(options)
  .then(response => dispatch(success(response.data)))
  .catch((error) => {
    console.log(error); // eslint-disable-line
    dispatch(failure(error));
  });


// post file request direct for partner
export const apiFilePostDirect = (dispatch, endpoint, success, failure, params) => axios(
  { method: 'post',
    data: { ...params },
    url: endpoint,
    responseType: 'blob',
    headers: { Pragma: 'no-cache', Authorization: getAuthorizationAccessTokenSecureAuth() },
  })
  .then((response) => {
    dispatch(success(response));
  })
  .catch((error) => {
    if (error.response && error.response.data && error.response.data.message) {
      sessionStorage.setItem('errorMessage', error.response.data.message);
    } else if (error.response === undefined) { // response will be undefined when okapi has rejected the request due to expired/incorrect token
      handleVantageAndMBSUndefinedError(dispatch, failure, error);
    }
    if (error.response && error.response.status === 401) {
      clearSessionStorage(CIP_LOGOUT_URL);
    } else {
      dispatch(failure(error));
    }
  });

export const apiPostDirect = (dispatch, endpoint, success, failure, params) => axios(
  { method: 'post',
    data: { ...params },
    url: endpoint,
    headers: { Pragma: 'no-cache', Authorization: getAuthorizationAccessTokenSecureAuth() },
  })
  .then((response) => {
    dispatch(success(response.data));
  })
  .catch((error) => {
    if (error.response && error.response.data && error.response.data.message && error.response.status !== 401) {
      sessionStorage.setItem('errorMessage', error.response.data.message);
      dispatch(failure(error));
    } else if (error.response === undefined) { // response will be undefined when okapi has rejected the request due to expired/incorrect token
      handleVantageAndMBSUndefinedError(dispatch, failure, error);
    } else if (error.response && error.response.status === 401) {
      clearSessionStorage(CIP_LOGOUT_URL);
    } else {
      dispatch(failure(error));
    }
  });


export default apiGet;
